import React from "react";
import { Link, useParams } from "react-router-dom";
import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useGetBranchAssignmentDetailQuery } from "store/services/branchAssignmentApi";

import { BranchAssignmentDetailContext } from "contexts/BranchAssignmentDetailContext";
import BranchAssignmentBasicDetail from "./BranchAssignmentComponents/BranchAssignmentBasicDetail";
import BranchAssignmentDetailTabs from "./BranchAssignmentComponents/BranchAssignmentDetailTabs";

const BranchAssignmentDetailScreen = () => {
  const { id } = useParams();
  const breadcrumbs = [
    { title: "Branch-Assignment", path: "/app/crm/branchAssignment/list" },
    { title: "Branch Assignment Detail" },
  ];
  const {
    data: branchAssignmentDetail,
    isLoading: loadingBranchAssignmentDetail,
    error,
  } = useGetBranchAssignmentDetailQuery(id);

  return (
    <BranchAssignmentDetailContext.Provider
      value={{ branchAssignmentDetail, loadingBranchAssignmentDetail }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingBranchAssignmentDetail}
        error={error}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Paper>
          <BranchAssignmentBasicDetail />

          <Divider />

          <BranchAssignmentDetailTabs />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </BranchAssignmentDetailContext.Provider>
  );
};

export default BranchAssignmentDetailScreen;

const PageActions = () => {
  const { id } = useParams();

  return (
    <Link to={`/app/crm/branchAssignment/${id}/edit`}>
      <Button variant="contained" startIcon={<EditOutlined />}>
        Edit
      </Button>
    </Link>
  );
};
